import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {  Button } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
// import { useState }  from 'react';
// import { Modal } from 'react-bootstrap';
// import FalconCloseButton from 'components/common/FalconCloseButton';
// import { useForm, Controller } from 'react-hook-form'

import { fetchElencoQuestionari } from 'features-csvc/reduxStore/elencoQuestionariSlice';
// import { creaNuovoQuestionario } from 'features-csvc/reduxStore/elencoQuestionariSlice'
import { setQuestionarioCorrente } from 'features-csvc/reduxStore/questCorrenteSlice';
import {
  setQuestionarioMenu,
  unsetQuestionarioMenu
} from 'features-csvc/reduxStore/siteMapsSlice';
import { useDispatch, useSelector } from 'react-redux';
// import Process from 'components/pages/landing/Process';

// import dotenv from 'dotenv'     // modulo per gestire il file .env per le variabili di ambiente

const API_URL = 'https://apis-csvc-v0-2faa314f421f.herokuapp.com' // <<== da sostituire con variabile d'ambiente in .env
// const API_URL = 'http://localhost:5700' // <<== da sostituire con variabile d'ambiente in .env


let questionariArray = [];

export const SelezionaQuestionarioAzienda = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAccediClicked = (QuestionarioUuidSelected) => {
    const questionarioSelected = questionariArray.filter(
      ({ questionarioUuid }) => questionarioUuid === QuestionarioUuidSelected
    );

    dispatch(
      setQuestionarioCorrente({
        questionarioUuid: questionarioSelected[0].questionarioUuid,
        aziendaNome: questionarioSelected[0].aziendaNome,
        noteQuestionario: questionarioSelected[0].noteQuestionario,
      })
    );

    dispatch(setQuestionarioMenu());
    navigate('/app/questionario');
  };

  // 1°: Recupero csvcUuid e csvcRole da utenteCorrenteSlice
  const csvcUuid = useSelector(
    (state) => state.utenteCorrente.csvcUuid
  );
  const csvcRole = useSelector((state) => state.utenteCorrente.csvcRole);
  // console.log ('SelezionaQuestionarioAzienda : ', csvcUuid, ' - ', csvcRole)

  // 2°: Richiedo al BackEnd tutti i questionari congruenti con csvcUuid e csvcRole for fetching an API on mount
  const { data, status, error, numberOfItem } = useSelector(
    (state) => state.elencoQuestionari
  );
  questionariArray = data;

  useEffect(() => {
    const endpoint = API_URL + '/questionari/elencoQuestionariByUserUuidAndUserRole/' +
    csvcUuid +
    '/' +
    csvcRole

    console.log (`elencoQuestionariByUserUuidAndUserRole ${endpoint}`)
    dispatch(   
      fetchElencoQuestionari( endpoint )
    );
  }, []);



  if (status === 'loading') {
    return <div className={`div-con-bordo`}>Caricamento questionari...</div>;
  } else if (status === 'succeded') {
    if (numberOfItem == 0) {
      return (
        <div className={`div-con-bordo`}>Non sono presenti questionari</div>
      );
    } else if (numberOfItem == 1) {
      // 3° - a:  Se ricevo un solo questionario, inizializzo questionarioCorrenteSlice con i
      //          suoi dati generali e non renderizzo l'elenco dei questionari
      handleAccediClicked(questionariArray[0].questionarioUuid);
    } else {
      // 3° - b:  Se ricevo più di un questionario renderizzo l'elenco dei questionari.
      const dispatch = useDispatch();
      dispatch(unsetQuestionarioMenu())

      return (
        <>
         <div className="table-responsive scrollbar">
            <Table className="fs-10 mb-0 overflow-hidden table table-striped table-bordered">
              <thead className="bg-200 text-nowrap align-middle">
                <tr>
                  <th key="aziendaNome" className="fs-10 text-900">
                    Azienda
                  </th>
                  <th key="azione" className="fs-10"></th>
                  <th key="emailUsername" className="fs-10 text-900">
                    Username (email)
                  </th>
                  <th key="statoLavorazione" className="fs-10 text-900">
                    Stato
                  </th>
                </tr>
              </thead>
              <tbody>
                {questionariArray.map((questionario) => (
                  <tr
                    key={questionario.questionarioUuid}
                    className="align-middle white-space-nowrap"
                  >
                    <td key="aziendaNome" className="fs-10 text-900">
                      {questionario.aziendaNome}
                    </td>
                    <td key="azione">
                      <Button
                        variant="primary"
                        onClick={() =>
                          handleAccediClicked(questionario.questionarioUuid)
                        }
                      >
                        Accedi
                      </Button>
                    </td>
                    <td key="emailUsername" className="fs-10 text-900">
                      {questionario.emailUsername}
                    </td>
                    <td key="statoLavorazione" className="fs-10 text-900">
                      {questionario.statoLavorazione === 'L'
                        ? 'in lavorazione'
                        : questionario.statoLavorazione === 'C'
                        ? 'completato'
                        : questionario.statoLavorazione === 'A'
                        ? 'annullato'
                        : 'stato indefinito'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      );
    }
  } else if (status === 'failed') {
    return (
      <div className={`div-con-bordo`}>
        Si è verificata la seguente eccezione: {error}
      </div>
    );
  } else {
    return (
      <div className={`div-con-bordo`}>
        Si è verificata la seguente eccezione: Stato {status}
      </div>
    );
  }
};

/*
                type Questionnaire = {
                  questionarioUuid: string
                  csvcUuid: string
                  emailUsername: string
                  aziendaNome: string
                  versioneQuestionario: number
                  statoLavorazione: string
                  annoRiferimentoItem: string
                  annoRiferimento: string
                }

*/

/*
//  COME GENERARE RIGA TITOLI DA ARRAY TITOLI IN ADVANCED TABLE FALCON
                        <thead className='bg-200 text-nowrap align-middle'>
                          <tr>
                            {getFlatHeaders().map(header => {
                              return (
                                <th
                                  key={header.id}
                                  {...header.column.columnDef.meta?.headerProps}
                                  className={classNames(
                                    'fs-10',
                                    header.column.columnDef.meta?.headerProps?.className,
                                    {
                                      sort: header.column.getCanSort(),
                                      desc: header.column.getIsSorted() === 'desc',
                                      asc: header.column.getIsSorted() === 'asc'
                                    }
                                  )}
                                  onClick={header.column.getToggleSortingHandler()}
                                >
                                  {header.isPlaceholder
                                    ? null
                                    : flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                      )}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>

*/

/*
// ELENCO QUESTIONARI:
                    <ul>
                        {data.map((questionario) => (<>
                          <li key='{questionario.questionarioUuid}'>
                            <button type="button" onClick={() => handleAccediClicked(questionario.questionarioUuid)}>Accedi</button>&nbsp;&nbsp;
                            {questionario.aziendaNome} - {questionario.emailUsername} ( {questionario.statoLavorazione} )
                          </li>
                        </>))}
                    </ul>
                    <br /><hr /><br />


                     handleAccediClicked(questionario.questionarioUuid)


const ages = [32, 33, 16, 40];
const result = ages.filter(checkAdult);

function checkAdult(age) {
  return age >= 18;
}
  

const ages = [32, 33, 16, 40];
const result = ages.filter((age) { return age >= 18 });

(age) { return age >= 18 }

*/
